var map = {
	"./bat-2.gif": 418,
	"./bat.gif": 419,
	"./fly.gif": 420,
	"./gezichtje.gif": 421,
	"./giraffe.gif": 422,
	"./sheep.gif": 423,
	"./wazeba-black.gif": 424,
	"./wazeba-white.gif": 425
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 417;